module.exports = __webpack_public_path__ + "img/wallet.10e423c8.svg";